import { ArrowLeft } from "lucide-react";
import { useTranslation } from 'react-i18next';
import { Button } from "@/components/ui/button";
import { LanguagePicker } from "@/components/LanguagePicker";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useNavigate } from "react-router-dom";

export function Preferences() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  return (
    <div className="p-6 space-y-8">
      {isMobile && (
        <div className="space-y-1">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/settings')}
            className="h-8 px-2 -ml-2 text-muted-foreground"
          >
            <ArrowLeft className="h-4 w-4 mr-1" />
            {t('settings')}
          </Button>
        </div>
      )}

      <div>
        <h1 className="text-xl font-semibold tracking-tight">{t('preferences')}</h1>
        <p className="text-sm text-muted-foreground mt-1">
          {t('preferencesDescription')}
        </p>
      </div>

      <div className="space-y-6">
        {/* Language */}
        <div className="space-y-3">
          <div>
            <h3 className="text-sm font-medium">{t('language')}</h3>
            <p className="text-sm text-muted-foreground">
              {t('languageDescription')}
            </p>
          </div>
          <div className="max-w-xs">
            <LanguagePicker />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Preferences;
